export const compareProductsStorageName = '_compare_products'
